(ns dre.pages.admin.ai-summarization-usage.db)

(def init-db
  {:filters {:from nil
             :to nil
             :include-dre false
             :include-browser true
             :include-api false
             :client nil
             :username nil}
   :user-list {:response nil
               :state nil}
   :client-list {:response nil
                 :state nil}
   :events {:response nil
            :state nil
            :pagination {:limit 10
                         :offset 0
                         :current-page 1}}})
